<!-- 导出 -->
<template>
  <Layout>
    <div class="row">
      <div class="outBox">
        <div class="failure flex-depart-left-center" @click="toDescribe">
          导出实例，保存失效说明 <i class="el-icon-arrow-right"></i>
        </div>
        <div class="dc-operate">
          <div class="operate-item">
            <div class="inner flex-depart-left-center">
              <img :src="dcImg1" alt="" />
              <span>导出表格（可含图片）</span>
            </div>

            <div
              class="change-tip"
              v-if="exportResultState === 2 && exportShowTips"
            >
              检测到活动有新增数据，建议重新生成
            </div>

            <div class="tip-box" v-if="exportResultState === 1">
              <div class="tip-wrap">
                <div class="tip-title">导出结果正在生成中</div>
                <div class="tip-subtitle">
                  预计<span style="color: #1877ff">{{
                    exportResultTimeText
                  }}</span
                  >内导出，导出的表格正在生成中......
                </div>
              </div>
            </div>
            <div class="tip-box" v-if="exportResultState === 2">
              <div class="tip-wrap">
                <div class="tip-created">
                  链接生成于{{ exportDataInfo.createdTime }}
                </div>
                <div class="tip-order">
                  <div>筛选条件： 时间范围为{{ exportDataInfo.condition }}</div>
                  <div class="expand-btn" @click="exportResultShow = true">
                    展开
                  </div>
                </div>
                <div class="tip-url">
                  导出链接： {{ exportDataInfo.downloadUrl }}
                </div>
              </div>
              <div class="reTryBtn" @click="openSelectBox">
                重新生成下载链接
              </div>
              <div class="btn-group">
                <div
                  class="btn-item"
                  @click="copyLink(exportDataInfo.downloadUrl)"
                >
                  复制文件下载链接
                </div>
                <div class="btn-item cursor">
                  <a :href="exportDataInfo.downloadUrl" download=""></a>
                  下载文件
                </div>
              </div>
            </div>

            <div
              class="operate-btn"
              @click="openSelectBox"
              v-if="exportResultState === 0"
            >
              点击生成下载链接
            </div>
          </div>
          <div class="operate-item">
            <div class="inner flex-depart-left-center">
              <img :src="dcImg2" alt="" />
              <span>打包导出图片/视频/文件</span>
            </div>
            <div
              class="change-tip"
              v-if="packResultState === 2 && packShowTips"
            >
              检测到活动有新增数据，建议重新生成
            </div>
            <div class="tip-box" v-if="packResultState === 1">
              <div class="tip-wrap">
                <div class="tip-title">导出结果正在生成中</div>
                <div class="tip-subtitle">
                  预计<span style="color: #1877ff">{{
                    packResultTimeText
                  }}</span
                  >内导出，导出的表格正在生成中......
                </div>
              </div>
            </div>
            <div class="tip-box" v-if="packResultState === 2">
              <div class="tip-wrap">
                <div class="tip-created">
                  链接生成于{{ packDataInfo.createdTime }}
                </div>
                <div class="tip-order">
                  <div>筛选条件： 时间范围为{{ packDataInfo.condition }}</div>
                  <div class="expand-btn" @click="packResultShow = true">
                    展开
                  </div>
                </div>
                <div class="tip-url">
                  导出链接： {{ packDataInfo.downloadUrl }}
                </div>
              </div>
              <div class="reTryBtn" @click="openPackPop">重新生成下载链接</div>
              <div class="btn-group">
                <div
                  class="btn-item"
                  @click="copyLink(packDataInfo.downloadUrl)"
                >
                  复制文件下载链接
                </div>
                <div class="btn-item cursor">
                  <a :href="packDataInfo.downloadUrl" download=""></a>
                  下载文件
                </div>
              </div>
            </div>

            <div
              class="operate-btn"
              @click="openPackPop"
              v-if="packResultState === 0"
            >
              点击生成下载链接
            </div>
          </div>
        </div>
        <div class="copy-box">
          <div class="co-title">复制名单文字</div>
          <div class="co-tips">
            将名单中填写信息以文字形式复制，可将复制粘贴到微信聊天窗口，即可发送。
          </div>
          <div class="operate-btn" @click="copyAndShareNameList">复制名单</div>
        </div>
        <div class="tip-wrapper">
          <div class="use_study_content">
            <div class="study_title">电脑上excel选项,参与人筛选教程</div>
            <div class="study_subtitle">
              ① 使用excel或wps打开后请<text class="zdtext">启用编辑</text>模式
            </div>

            <div class="study_subtitle">
              ② 点击 <text>数据</text>选项卡中的 <text>筛选</text>按钮
            </div>
            <img
              mode="widthFix"
              style="width: 94%; margin: 20rpx; margin-left: 3%"
              src="https://ossfytp.mustke.com/image/newStyleImages/excelstudy1.png"
            />
            <div class="study_subtitle">
              ③点击每一项的<text>下箭头图标,即可筛选</text>
            </div>
            <img
              mode="widthFix"
              style="width: 94%; margin: 20rpx; margin-left: 3%"
              src="https://ossfytp.mustke.com/image/newStyleImages/excelstudy2.jpg"
            />
            <div class="study_subtitle">
              ④ 需要<text>统计每项数据</text> 可以点击
              <text>插入</text> 选项卡，点击 <text>推荐的数据透视表</text>。
            </div>
            <img
              mode="widthFix"
              style="width: 94%; margin: 20rpx; margin-left: 3%"
              src="https://ossfytp.mustke.com/image/newStyleImages/excelstudy3.png"
            />
            <div class="preview_effect">
              <text>预览效果：</text>
              <img
                mode="widthFix"
                style="width: 94%; margin: 20rpx; margin-left: 3%"
                src="https://ossfytp.mustke.com/image/newStyleImages/excelstudy4.png"
              />
            </div>
          </div>
        </div>
        <div class="tips-box">
          <p class="tips-title">如何在电脑上打开导出的文件?</p>
          <p class="t-small">1、点击导出表格，成功后复制下载链接；</p>
          <p class="t-small">2、在微信手机端找到"文件传输助手"；</p>
          <p class="t-small">3、粘贴链接地址并发送；</p>
          <p class="t-small">4、在微信电脑客户端找到"文件传输助手"；</p>
          <p class="t-small">
            5、复制链接,打开浏览器粘贴链接，直接下载保存Excel表格；
          </p>
          <p class="t-small">6、如果超时或者导出失败，请切换图片清晰度；</p>
        </div>
      </div>
    </div>
    <template>
      <!-- 弹出层-导出配置1 -->
      <el-dialog
        title="请选择"
        :visible.sync="selectBoxShow"
        width="450px"
        :show-close="false"
      >
        <template slot="title">
          <CustomDialogHeader title="请选择" @close="selectBoxShow = false" />
        </template>
        <div>
          <div class="pics" style="margin-top: -30px">
            <div
              class="img-box"
              :class="{ 'select-active': exportMethod == 1 }"
              @click="changeHasImg(1)"
            >
              <img class="excaImg" :src="selectImg1" />
              <img
                class="select-img"
                :src="selectImg3"
                v-if="exportMethod == 1"
              />
            </div>
            <div
              class="img-box"
              :class="{ 'select-active': exportMethod == 2 }"
              @click="changeHasImg(2)"
            >
              <img class="excaImg" :src="selectImg2" />
              <img
                class="select-img"
                :src="selectImg3"
                v-if="exportMethod == 2"
              />
            </div>
          </div>
          <div class="sort-box">
            <div class="sort-title">排序方式</div>
            <el-radio-group v-model="exportOrder" @change="orderChange">
              <el-radio
                v-for="(item, index) in exportArr"
                :key="index"
                :disabled="item.disabled"
                :label="item.id"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="sort-box" v-if="imageClarityShow == true">
            <div class="sort-title">图片清晰度</div>
            <el-radio-group v-model="exportType" @change="imageClarityChange">
              <el-radio
                v-for="(item, index) in exportImgArr"
                :key="index"
                :label="item.id"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="nextBtn" @click="nextFn">下一步</div>
        </div>
      </el-dialog>

      <!-- 弹出层-导出配置2 -->
      <el-dialog
        title="请选择"
        :visible.sync="summaryBoxShow"
        width="450px"
        :show-close="false"
      >
        <template slot="title">
          <CustomDialogHeader title="请选择" @close="summaryBoxShow = false" />
        </template>
        <div>
          <div class="sort-box" style="border-top: 0; margin-top: -30px">
            <div class="sort-title">汇总方式</div>
            <el-radio-group
              v-model="fileAttachmentType"
              @change="fileAttachmentChange"
            >
              <el-radio
                v-for="(item, index) in fileAttachmentArr"
                :key="index"
                :label="item.id"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </div>

          <div class="sort-box">
            <div class="sort-title">命名方式</div>
            <el-checkbox-group v-model="naming" @change="namingSelectChange">
              <el-checkbox
                v-for="(item, index) in namingList"
                :key="index"
                :label="item.id"
              >
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>

          <div class="sort-box">
            <div class="sort-title">图片清晰度</div>
            <el-radio-group
              v-model="exportPackType"
              @change="imageClarityPackChange"
            >
              <el-radio
                v-for="(item, index) in exportImgPackArr"
                :key="index"
                :label="item.id"
              >
                {{ item.name }}
              </el-radio>
            </el-radio-group>
          </div>

          <div class="sort-box">
            <div class="sort-title">导出的项目</div>
            <el-checkbox-group
              v-model="importFormSelectVal"
              @change="formSelectChange"
            >
              <el-checkbox
                v-for="(item, index) in importFormData"
                :key="index"
                :label="item.id"
              >
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="nextBtn" @click="nextFn">下一步</div>
        </div>
      </el-dialog>

      <el-dialog
        title="筛选导出范围"
        :visible.sync="filterTimesBoxShow"
        width="450px"
        :before-close="cancelFTSet"
        :show-close="false"
      >
        <template slot="title">
          <CustomDialogHeader
            title="筛选导出范围"
            @close="filterTimesBoxShow = false"
          />
        </template>
        <div class="s-times-box" style="margin: -20px 0">
          <div
            class="times-item"
            v-for="item in timeFilterArr"
            :key="item.type"
            :class="{ 'times-item-active': item.active == true }"
            @click="currentSelect(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="sort-box">
          <div class="sort-title">自定义日期</div>
          <div class="timeRangeOutBox flex-depart-center">
            <el-date-picker
              v-model="startQueryTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span style="padding-left: 10px; padding-right: 10px">-</span>
            <el-date-picker
              v-model="endQueryTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelFTSet">取 消</el-button>
          <el-button type="primary" @click="submitFn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 弹出层-导出表格 -->
      <el-dialog
        title="表格导出筛选条件"
        :visible.sync="exportResultShow"
        width="600px"
      >
        <div class="result-box">
          <div class="export-result">
            <div class="result-item">
              <div class="result-item-title">导出类型</div>
              <div class="result-item-value">
                {{ exportDataInfo.exportTypeText }}
              </div>
            </div>
            <div class="result-item">
              <div class="result-item-title">排序方式</div>
              <div class="result-item-value">{{ exportDataInfo.orderBy }}</div>
            </div>
            <div class="result-item">
              <div class="result-item-title">导出范围</div>
              <div class="result-item-value">
                {{ exportDataInfo.condition }}
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 弹出层-打包 -->
      <el-dialog
        title="打包导出筛选条件"
        :visible.sync="packResultShow"
        width="600px"
      >
        <div class="result-box">
          <div class="export-result">
            <div class="result-item">
              <div class="result-item-title">导出类型</div>
              <div class="result-item-value">
                {{ packDataInfo.exportTypeText }}
              </div>
            </div>
            <div class="result-item">
              <div class="result-item-title">命名方式</div>
              <div class="result-item-value">{{ packDataInfo.namingText }}</div>
            </div>
            <div class="result-item">
              <div class="result-item-title">导出范围</div>
              <div class="result-item-value">{{ packDataInfo.condition }}</div>
            </div>
            <div class="result-item">
              <div class="result-item-title">导出的项目</div>
              <div class="result-item-value">
                {{ packDataInfo.projectText }}
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <el-dialog title="导出数据超出限额" :visible.sync="UsePop" width="1100px">
        <div class="out-box">
          <div
            class="title"
            style="
              margin-bottom: 10px;
              margin-top: -20px;
              font-size: 15px;
              color: #636a84;
            "
          >
            您导出的数据已经超过限制导出的最大额度，请<span
              style="color: #1877ff"
              >联系客服</span
            >导出或分时间导出。
          </div>
          <div>
            <img
              style="display: block; width: 100%"
              src="https://ossfastmake.mustke.com/12jielong/bdJL/export-limit.png"
              alt=""
            />
          </div>
        </div>
      </el-dialog>
    </template>
  </Layout>
</template>

<script>
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";
var dayjs = require("dayjs");
const d = new Date();
const year = d.getFullYear();
let month = d.getMonth() + 1;
month = month < 10 ? `0${month}` : month;
const date = d.getDate();

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import axios from "axios";

import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";

import {
  orderListByChoose,
  imageAndVideoFiles,
  activityListItems,
  getShareLink,
  setFileLink,
  selFileLink,
  allowExport,
  exportTime,
  updateTip,
} from "@/utils/api/activity";
import { activityDetail } from "@/utils/api/build";
export default {
  page() {
    return {
      title: `${this.actName} - 数据导出`,
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: { Layout, CustomDialogHeader },
  data() {
    return {
      UsePop: false,
      exportShowTips: false,
      packShowTips: false,
      // 导出结果正在生成中 0 未生成 1 生成中 2 生成完成
      exportResultState: 0,
      exportResultTime: 0,
      exportDataInfo: {
        // 下载链接
        downloadUrl: "",
        condition: "",
        orderBy: "",
        createdTime: "2025-09-30 10:00:00",
        exportTypeText: "表格",
      },
      exportResultShow: false,
      packResultState: 0,
      packResultTime: 0,
      packDataInfo: {
        // 下载链接
        downloadUrl: "",
        condition: "",
        orderBy: "",
        createdTime: "2025-09-30 10:00:00",
        exportTypeText: "表格",
        namingText: "",
        projectText: "",
      },
      packResultShow: false,
      exportTimer: null,
      packTimer: null,
      dcImg1:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/daochu-excel.svg",
      dcImg2:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/daochu-wenjianjia.svg",
      selectBoxShow: false,
      selectImg1:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/daochu-noImg.png",
      selectImg2:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/daochu-hasImg.png",
      selectImg3:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/daochu-selected.png",
      exportOrder: 2, // 导出顺序 1 按照名单顺序导出 2 按照报名时间正序导出 3 按照报名时间倒序导出
      exportArr: [
        {
          name: "按照名单顺序导出",
          id: 1,
          disabled: false,
        },
        {
          name: "按照报名时间正序导出",
          id: 2,
          disabled: false,
        },
        {
          name: "按照报名时间倒序导出",
          id: 3,
          disabled: false,
        },
      ],
      exportType: 1, // 导出图片清晰度 1 excel标准图  2 excel原图
      exportImgArr: [
        {
          name: "标准",
          id: 1,
          disabled: false,
        },
        {
          name: "原图",
          id: 2,
          disabled: false,
        },
      ],
      exportPackType: 3, // 导出图片清晰度 31 excel标准图  4 excel原图
      exportImgPackArr: [
        {
          name: "标准",
          id: 3,
          disabled: false,
        },
        {
          name: "原图",
          id: 4,
          disabled: false,
        },
      ],
      checkboxValue1: [],
      // 基本案列数据
      checkboxList1: [
        {
          name: "苹果",
          disabled: false,
        },
        {
          name: "香蕉",
          disabled: false,
        },
        {
          name: "橙子",
          disabled: false,
        },
      ],
      summaryBoxShow: false,
      filterTimesBoxShow: false,
      timeFilterArr: [
        {
          title: "全部",
          active: true,
          type: 0,
        },
        {
          title: "今天",
          active: false,
          type: 1,
        },
        {
          title: "昨天",
          active: false,
          type: 2,
        },
        {
          title: "最近三天",
          active: false,
          type: 3,
        },
        {
          title: "本周",
          active: false,
          type: 4,
        },
        {
          title: "上周",
          active: false,
          type: 5,
        },
        {
          title: "本月",
          active: false,
          type: 6,
        },
        {
          title: "上月",
          active: false,
          type: 7,
        },
      ],

      startTime: "",
      endTime: "",
      range: ["2021-02-1", "2021-3-28"],
      mode: "range",
      timeShow: false,
      activityId: "",
      isDownLoad: 0,
      startQueryTime: "",
      endQueryTime: "",
      exportMethod: 1,
      nameList: [],
      imageClarityShow: false,
      timeValue: "自定义日期",
      actInfo: {},
      singInfo: [],
      importFormData: [], // 所有表单项
      importFormSelectVal: [],
      fileAttachmentType: 1, // 汇总文件夹形式 0 所有人在一个文件夹  1 每个人单独一个文件夹
      fileAttachmentArr: [
        {
          name: "所有人在一个文件夹",
          id: 0,
          disabled: false,
        },
        {
          name: "每个人单独一个文件夹",
          id: 1,
          disabled: false,
        },
      ],
      isPack: 1, // 1 导出 2 打包
      signListName: [],
      clockNameList: [],
      copyUrl: "",
      shareNameStr: "",
      naming: [3],
      namingList: [
        {
          id: 1,
          name: "姓名",
        },
        {
          id: 2,
          name: "题目标题",
        },
        {
          id: 3,
          name: "文件原名",
        },
        {
          id: 4,
          name: "提交日期",
        },
        {
          id: 5,
          name: "微信昵称",
        },
      ],
      minDateMultiple: "",
      defaultDateMultiple: [`${year}-${month}-${date - 1}`],
      startTimeShow: false,
      endTimeShow: false,
      signInfo: [],
      actName: "",
      loading: {},
      activityKey: "",
    };
  },
  computed: {
    exportResultTimeText() {
      return this.exportResultTime > 0
        ? this.exportResultTime > 60
          ? Math.ceil(this.exportResultTime / 60) + "分钟"
          : this.exportResultTime + "秒"
        : "马上";
    },
    packResultTimeText() {
      return this.packResultTime > 0
        ? this.packResultTime > 60
          ? Math.ceil(this.packResultTime / 60) + "分钟"
          : this.packResultTime + "秒"
        : "马上";
    },
  },
  async mounted() {
    // 页面参数
    this.routeParameter = this.$route.query;
    if (this.routeParameter.activityId) {
      this.activityId = this.routeParameter.activityId;
    }
    if (this.routeParameter.alias) {
      this.activityKey = this.routeParameter.alias;
    }
    this._activityListItems();
    await this._activityDetail();
    // this.getExportTime();
    this._selFileLink();
    // this._updateTip();
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },
  methods: {
    getExportTime() {
      exportTime({
        activityId: this.activityId,
      }).then((res) => {
        if (res.status === 1 && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.type === 1) {
              this.exportResultState = 1;
              this.exportResultTime = item.remainderTimeNum;
              // 倒计时轮询
              this.exportTimer = setInterval(() => {
                if (this.exportResultTime > 0) {
                  --this.exportResultTime;
                }
                if (this.exportResultTime <= 0) {
                  this.exportTimer && clearInterval(this.exportTimer);
                  this._selFileLink();
                }
              }, 1000);
            }
            if (item.type === 2) {
              this.packResultState = 1;
              this.packResultTime = item.remainderTimeNum;
              this.packTimer = setInterval(() => {
                if (this.packResultTime > 0) {
                  --this.packResultTime;
                }
                if (this.packResultTime <= 0) {
                  this.packTimer && clearInterval(this.packTimer);
                  this._selFileLink();
                }
              }, 1000);
            }
          });
        } else {
          this._selFileLink();
        }
      });
    },
    async _updateTip() {
      // 定义请求逻辑函数
      const fetchTipData = async () => {
        let { msg, status, data } = await updateTip({
          activityId: this.activityId,
        });
        if (status === 1) {
          this.exportShowTips = data.link === 1;
          this.packShowTips = data.document === 1;
        }
      };

      // 立即执行一次请求
      await fetchTipData();

      // 然后每3秒执行一次
      this.tipTimer = setInterval(fetchTipData, 3000);
    },
    copyLink(downloadUrl) {
      this.copyTextToClipboard(downloadUrl);
      this.$message("复制成功");
    },
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      document.title = `导出数据 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    // 统一管理弹窗关闭方法
    closePopup(type) {
      console.log(type);
      switch (type) {
        case "select":
          this.selectBoxShow = false;
          break;
        case "summary":
          this.summaryBoxShow = false;
          break;
        case "filterTimes":
          this.filterTimesBoxShow = false;
          break;
        case "timeRange":
          this.timeShow = false;
          break;
      }
    },
    toDescribe() {
      var url = "https://mp.weixin.qq.com/s/N1en8PlcwlcR1qZBJQ0Cnw";
      window.open(url, "_blank");
    },
    async submitFn() {
      // 验证时间字段
      if (this.startQueryTime || this.endQueryTime) {
        if (!this.startQueryTime || !this.endQueryTime) {
          this.$message("开始时间和结束时间必须同时填写");
          return;
        }

        // 将时间字符串转换为时间戳进行比较
        const startTime = new Date(this.startQueryTime).getTime();
        const endTime = new Date(this.endQueryTime).getTime();

        if (startTime > endTime) {
          this.$message("开始时间不能大于结束时间");
          return;
        }
      }
      // this.loading = this.$loading({
      //     lock: true,
      //     text: '正在生成...',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // });

      const res = await allowExport({
        activityId: this.activityId,
        type: this.isPack,
      });
      if (res.status === 0) {
        this.UsePop = true;
        return;
      }

      if (this.isPack === 1) {
        this.exportResultTime = res.data;
      } else {
        this.packResultTime = res.data;
      }

      this.filterTimesBoxShow = false;
      if (this.isPack == 1) {
        this._orderListByChoose();
      } else {
        this._imageAndVideoFiles();
      }
    },
    async _selFileLink() {
      let { status, data } = await selFileLink({
        activityId: this.activityId,
      });
      console.log(data, "data");
      console.log(status, "status");
      if (status === 1) {
        data.forEach((item) => {
          if (item.linkType === 1) {
            this.exportResultState = 2;
            const resultInfo = JSON.parse(item.screeningScope);
            this.exportDataInfo = {
              ...resultInfo,
              createdTime: item.addTime,
              downloadUrl: item.fileUrl,
            };
          }
          if (item.linkType === 2) {
            this.packResultState = 2;
            const resultInfo = JSON.parse(item.screeningScope);
            this.packDataInfo = {
              ...resultInfo,
              createdTime: item.addTime,
              downloadUrl: item.fileUrl,
            };
          }
        });
      }
    },
    async _setFileLink(row) {
      let result = await setFileLink({
        activityId: this.activityId,
        linkType: row.linkType,
      });
    },
    // 导出
    _orderListByChoose() {
      this.exportResultState = 1;
      this.exportShowTips = false;
      const resultInfo = {
        condition: this.startQueryTime
          ? this.startQueryTime + " - " + this.endQueryTime
          : "全部",
        orderBy: this.exportArr.filter((item) => item.id == this.exportType)[0]
          .name,
        exportTypeText: ["表格", "表格插入图片"][this.exportType - 1],
      };
      orderListByChoose({
        activityId: this.activityId,
        exportType: this.exportType,
        isDownLoad: 0,
        exportOrder: this.exportOrder,
        exportMethod: this.exportMethod,
        startQueryTime: this.startQueryTime,
        endQueryTime: this.endQueryTime,
        type: 1,
        userId: localStorage.getItem("userID"),
        screeningScope: JSON.stringify(resultInfo),
      });
      this._setFileLink({
        linkType: 1,
      });
      // 倒计时轮询
      this.exportTimer = setInterval(() => {
        if (this.exportResultTime > 0) {
          --this.exportResultTime;
        }
        if (this.exportResultTime <= 0) {
          this.exportTimer && clearInterval(this.exportTimer);
          console.log("========");

          this._selFileLink();
        }
      }, 1000);
      // console.log(result, "导出方法");

      // if (result.status == 1) {
      //   // this.loading.close();
      //   if (result.msg === "-1") {
      //     this.$message("暂无数据，请重新筛选");
      //     return false;
      //   }

      //   this.exportDataInfo = {
      //     ...resultInfo,
      //     createdTime: new Date().toLocaleString(),
      //     downloadUrl: result.msg,
      //   };
      //   // this._setFileLink(
      //   //   {
      //   //     fileUrl: result.msg,
      //   //     linkType: 1,
      //   //   },
      //   //   JSON.stringify(resultInfo)
      //   // );
      //   setTimeout(() => {
      //     this.exportResultState = 2;
      //   }, 1000);
      //   // 编码
      //   // var downloadUrl = '';
      //   // downloadUrl = encodeURIComponent(result.msg);
      //   // var actName = '';
      //   // actName = encodeURIComponent(this.actName);
      //   // // uni.navigateTo({
      //   // //     url: '/pages-views/exportSuccessPage/exportSuccessPage?downloadUrl=' + downloadUrl + '&actName=' + actName
      //   // // })
      //   // let routeData = this.$router.resolve({
      //   //     path: "/exportSuccessPage?downloadUrl=" + downloadUrl + '&actName=' + actName,
      //   // });
      //   // window.open(routeData.href, "_blank");
      // } else {
      //   this.loading.close();
      //   this.$message("result.msg");
      // }
    },
    // 打包
    _imageAndVideoFiles() {
      this.packResultState = 1;
      this.packShowTips = false;
      const resultInfo = {
        condition: this.startQueryTime
          ? this.startQueryTime + " - " + this.endQueryTime
          : "全部",
        orderBy: this.exportArr.filter((item) => item.id == this.exportType)[0]
          .name,
        exportTypeText: this.fileAttachmentArr.filter(
          (item) => item.id == this.fileAttachmentType
        )[0].name,
        namingText: this.namingList
          .filter((item) => this.naming.includes(item.id))
          .map((item) => item.name)
          .join("-"),
        projectText: this.importFormData
          .filter((item) => this.importFormSelectVal.includes(item.id))
          .map((item) => item.name)
          .join("、"),
      };
      imageAndVideoFiles({
        activityId: this.activityId,
        exportType: this.exportPackType,
        fileAttachmentType: this.fileAttachmentType,
        signListName: this.signListName,
        naming: this.naming,
        startQueryTime: this.startQueryTime,
        endQueryTime: this.endQueryTime,
        userId: localStorage.getItem("userID"),
        type: 2,
        screeningScope: JSON.stringify(resultInfo),
      });
      this._setFileLink({
        linkType: 2,
      });
      // 倒计时轮询
      this.packTimer = setInterval(() => {
        if (this.packResultTime > 0) {
          --this.packResultTime;
        }
        if (this.packResultTime <= 0) {
          this.packTimer && clearInterval(this.packTimer);
          console.log("-----------------");
          this._selFileLink();
        }
      }, 1000);
      // console.log(result, "导出方法");
      // if (result.status == 1) {
      //   // this.loading.close();
      //   if (result.msg === "-1") {
      //     this.$message("暂无数据，请重新筛选");
      //     return false;
      //   }

      //   this.packDataInfo = {
      //     ...resultInfo,
      //     createdTime: new Date().toLocaleString(),
      //     downloadUrl: result.msg,
      //   };
      //   this._setFileLink(
      //     {
      //       fileUrl: result.msg,
      //       linkType: 2,
      //     },
      //     JSON.stringify(resultInfo)
      //   );
      //   setTimeout(() => {
      //     this.packResultState = 2;
      //   }, 1000);
      //   // 编码
      //   // var downloadUrl = '';
      //   // downloadUrl = encodeURIComponent(result.msg)
      //   // var actName = '';
      //   // actName = encodeURIComponent(this.actName);
      //   // // uni.navigateTo({
      //   // //     url: '/pages-views/exportSuccessPage/exportSuccessPage?downloadUrl=' + downloadUrl + '&actName=' + actName
      //   // // })
      //   // let routeData = this.$router.resolve({
      //   //     path: "/exportSuccessPage?downloadUrl=" + downloadUrl + '&actName=' + actName,
      //   // });
      //   // window.open(routeData.href, "_blank");
      // } else {
      //   // this.loading.close();
      //   this.$message("result.msg");
      // }
      // this.filterTimesBoxShow = false;
    },
    async _activityListItems() {
      let result = await activityListItems({
        activityKey: this.activityKey,
      });
      console.log(result, "填表项");
      this.signInfo = result.data;
      // 过滤出指定 type 的数据并转换格式
      this.importFormData = this.signInfo
        .filter((item) => [5, 7, 32].includes(item.type))
        .map((item) => ({
          id: item.id,
          name: item.fieldName,
          type: item.type,
        }));
    },
    async _getShareLink() {
      this.loading = this.$loading({
        lock: true,
        text: "生成名单中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let res = await getShareLink({
        activityId: this.activityId,
      });
      if (res.status == 1) {
        this.copyUrl = res.data.shareLink;
        // 生成复制名单内容
        const nameStr = this.nameList.join("\n");
        this.shareNameStr = `${this.actName}\n┄┄┄┄┄┄┄┄┄┄┄┄┄\n${nameStr}\n点击下方链接，进入小程序接龙\n${this.copyUrl}`;
        this.loading.close();
        this.copyTextToClipboard(this.shareNameStr);
      }
    },
    async copyTextToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        console.log("Text copied to clipboard successfully!");
        this.$message({
          type: "success",
          message: "复制成功",
        });
      } catch (err) {
        console.error("Could not copy text: ", err);
        // 如果Clipboard API不可用，则使用备用方案
        this.fallbackCopyTextToClipboard(text);
      }
    },
    fallbackCopyTextToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // 避免在页面滚动时出现问题
      textarea.style.top = "-9999px";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        const msg = successful ? "successful" : "unsuccessful";
        console.log("Text copy was " + msg);
      } catch (err) {
        console.error("Could not copy text: ", err);
      } finally {
        document.body.removeChild(textarea);
      }
    },
    copyAndShareNameList() {
      if (this.clockNameList.length == 0) {
        this.$message("暂无名单");
        return false;
      }
      this._getShareLink();
    },
    // 获取活动详情
    async _activityDetail() {
      var obj = {
        activityKey: this.activityKey,
        selectType: "see",
      };
      const { data, msg, status } = await activityDetail(obj);
      if (status == 1) {
        this.actInfo = data.activityDetail;
        this.actName = data.activityDetail.name;
        this.clockNameList = data.clockNameList;
        this.minDateMultiple = data.activityDetail.beginTime.substring(0, 10);
        this.activityId = data.activityDetail.id;
        if (this.clockNameList && this.clockNameList.length > 0) {
          this.nameList = [];
          this.clockNameList.forEach((item) => {
            this.nameList.push(item.clockName);
          });
        } else {
          this.exportArr.forEach((item) => {
            if (item.id == 1) {
              item.disabled = true;
            }
          });
        }
      }
    },
    timeRangeConfirm(e) {
      this.startQueryTime = e[0];
      this.endQueryTime = e[e.length - 1];
      this.timeValue = this.startQueryTime + " ~ " + this.endQueryTime;
      this.timeShow = false;
    },

    timeRangeConfirmFn1(e) {
      this.startQueryTime = e[0];
      this.startTimeShow = false;
    },

    timeRangeConfirmFn2(e) {
      this.endQueryTime = e[0];
      this.endTimeShow = false;
    },

    cancelSet() {
      this.selectBoxShow = false;
      this.summaryBoxShow = false;
    },
    cancelFTSet() {
      this.filterTimesBoxShow = false;
    },
    openSelectBox() {
      this.selectBoxShow = true;
      this.isPack = 1;
    },
    openPackPop() {
      if (this.importFormData.length == 0) {
        this.$message("暂无可打包的项目");
        return false;
      }
      this.summaryBoxShow = true;
      this.isPack = 2;
    },

    changeHasImg(mode) {
      this.exportMethod = mode; // 原子化赋值操作
      this.imageClarityShow = mode === 2; // 使用严格等式+隐式布尔转换
    },
    nextFn() {
      if (this.isPack == 2) {
        if (this.naming.length == 0) {
          this.$message("请选择命名方式");
          return false;
        }
        if (this.signListName.length == 0) {
          this.$message("请选择要打包的项目");
          return false;
        }
      }
      this.selectBoxShow = false;
      this.summaryBoxShow = false;
      this.filterTimesBoxShow = true;
    },

    fileAttachmentChange(n) {
      this.fileAttachmentType = n;
    },

    formSelectChange(e) {
      console.log(e);
      this.importFormSelectVal = e;
      // 处理筛选并拼接字符串
      const result = this.importFormSelectVal
        .map((id) => {
          const item = this.importFormData.find((data) => data.id === id);
          return item ? `${item.name}` : "";
        })
        .filter((part) => part) // 过滤掉无效项（空字符串）
        .join(","); // 拼接所有部分
      this.signListName = result.split(",");
    },

    namingSelectChange(e) {
      this.naming = e;
    },

    orderChange(n) {
      this.exportOrder = n;
    },
    imageClarityChange(n) {
      this.exportType = n;
    },
    imageClarityPackChange(n) {
      this.exportPackType = n;
    },
    radioChange(n) {
      console.log("radioChange", n);
    },
    previousStep() {
      this.filterTimesBoxShow = false;
      if (this.isPack == 1) {
        this.selectBoxShow = true;
      } else {
        this.summaryBoxShow = true;
      }
    },
    currentSelect(item) {
      console.log(item.type, "typene");
      this.timeFilterArr.forEach((v) => (v.active = false));
      item.active = true;

      const padZero = (n) => n.toString().padStart(2, "0");
      const format = (date) =>
        `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(
          date.getDate()
        )}`;

      const today = new Date();
      let start, end;

      switch (item.type) {
        case 0: // 全部
          this.startTime = "";
          this.endTime = "";
          this.timeValue = "自定义日期";
          this.startQueryTime = "";
          this.endQueryTime = "";
          return;

        case 1: // 今天
          start = end = today;
          break;

        case 2: // 昨天
          var yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          start = end = yesterday;
          break;

        case 3: // 最近三天
          start = new Date(today);
          start.setDate(today.getDate() - 2);
          end = today;
          break;

        case 4: // 本周（周一到周日）
          start = new Date(today);
          // 计算到本周一的差值（当today.getDay()=1(周一)时，差0天）
          var dayDiff = (today.getDay() + 6) % 7;
          start.setDate(today.getDate() - dayDiff);
          end = new Date(start);
          end.setDate(start.getDate() + 6);
          break;

        case 5: // 上周（周一到周日）
          // 先找到本周一
          var thisMonday = new Date(today);
          thisMonday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
          // 上周日是本周一减1天
          end = new Date(thisMonday);
          end.setDate(thisMonday.getDate() - 1);
          // 上周一是上周日减6天
          start = new Date(end);
          start.setDate(end.getDate() - 6);
          break;

        case 6: // 本月（1号到当月最后一天）
          start = new Date(today.getFullYear(), today.getMonth(), 1);
          end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // 关键修改点
          break;

        case 7: // 上月
          start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          end = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
      }

      this.startTime = format(start);
      this.endTime = format(end);

      this.startQueryTime = this.startTime;
      this.endQueryTime = this.endTime;

      this.timeValue = this.startQueryTime + " ~ " + this.endQueryTime;
    },
    timeRangeChange(e) {
      console.log(e, "范围");
    },
    closeTimeRange() {
      this.timeShow = false;
      this.startTimeShow = false;
      this.endTimeShow = false;
    },
  },
  destroyed() {
    if (this.tipTimer) {
      clearInterval(this.tipTimer);
      this.tipTimer = null;
    }
    if (this.packTimer) {
      clearInterval(this.packTimer);
      this.packTimer = null;
    }
    if (this.exportTimer) {
      clearInterval(this.exportTimer);
      this.exportTimer = null;
    }
  },
};
</script>
<style lang="scss" scoped>
.outBox {
  width: 1000px;
  margin: 0 auto;
  background-color: #fbfbfb;
}

.failure {
  height: 50px;
  font-size: 15px;
  color: #1877ff;
  background-color: white;
  padding-left: 10px;
  border-top: 1px solid #eee;
  line-height: 50px;
  cursor: pointer;
}

.dc-operate {
  background-color: white;
  margin-top: 10px;
}

.operate-item {
  padding: 15px 10px;

  .change-tip {
    font-size: 12px;
    color: #f73b42;
    padding: 8px 0 0;
  }

  .tip-box {
    .tip-wrap {
      margin-top: 10px;
      background: #f9f9f9;
      border-radius: 5px;
      padding: 12px 10px;

      .tip-title {
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        color: #2b2f36;
        line-height: 15px;
        margin-bottom: 5px;
      }

      .tip-subtitle {
        font-size: 13px;
        color: #969ca7;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        line-height: 15px;
      }

      .tip-created {
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        color: #969ca7;
        line-height: 15px;
        margin-bottom: 5px;
      }

      .tip-order {
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        color: #2b2f36;
        line-height: 15px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .expand-btn {
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: Regular;
          text-decoration: underline;
          color: #1877ff;
          line-height: 15px;
          cursor: pointer;
        }
      }

      .tip-url {
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: Regular;
        text-align: left;
        color: #2b2f36;
        line-height: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
    }

    .reTryBtn {
      margin-top: 10px;
      height: 40px;
      background: #1877ff;
      border-radius: 5px;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: Medium;
      color: #ffffff;
      cursor: pointer;
    }

    .btn-group {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .btn-item {
        flex: 1;
        height: 40px;
        border: 1px solid #1877ff;
        border-radius: 5px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        color: #1877ff;
        cursor: pointer;

        &.cursor {
          position: relative;

          a {
            height: 100%;
            width: 100%;
            display: inline-block;
            opacity: 0;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
}

.result-box {
  margin: -30px -20px;
}

.export-result {
  background: #f9f9f9;
  border-radius: 5px;
  margin: 12px;

  .result-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    margin: 0 10px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    color: #949eaf;

    .result-item-title {
      color: #949eaf;
    }

    .result-item-value {
      max-width: 400px;
      color: #2b2f36;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.inner img {
  width: 16px;
  height: 17.5px;
  margin-right: 10px;
}

.inner span {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #4c4a56;
}

.operate-btn {
  width: 600px;
  height: 38px;
  background: #1877ff;
  border-radius: 20px;
  color: white;
  font-size: 14px;
  line-height: 38px;
  text-align: center;
  margin: 15px auto 0;
  cursor: pointer;
}

.copy-box {
  padding: 15px 10px;
  background-color: white;
  margin-top: 10px;
}

.co-title {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #4c4a56;
}

.co-tips {
  font-size: 13px;
  text-align: left;
  color: #a7adc6;
  line-height: 18px;
  margin-top: 10px;
}

.tips-box {
  padding: 15px 10px;
  margin-top: 10px;
}

.tips-title {
  font-size: 13px;
  font-weight: bold;
  text-align: left;
  color: #7e7e81;
  margin-bottom: 10px;
}

.t-small {
  font-size: 13px;
  text-align: left;
  color: #7e7e81;
  line-height: 23px;
}

.reject-con {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;

  .close-xsxq {
    position: absolute;
    right: 10px;
    top: 15px;

    image {
      height: 20px;
      width: 20px;
    }
  }

  .top-title {
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #e7e7e7;

    text {
      font-size: 18px;
      font-weight: bold;
      color: #2b2f36;
    }

    .re-close {
      position: absolute;
      right: 10px;
      top: 14px;
    }
  }
}

.tishi-title {
  line-height: 50px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  color: #333;

  text {
    color: #4a73f8;
  }
}

.pics {
  padding: 15px 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.img-box {
  width: 170px;
  height: 155px;
  position: relative;

  .excaImg {
    width: 170px;
    height: 155px;
    border: 1px solid rgba(255, 255, 255, 0);
    border-radius: 10px;
  }
}

.select-img {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 18px;
  height: 20px;
}

.select-active {
  .excaImg {
    border: 1px solid #1877ff;
  }
}

.sort-box {
  width: 94%;
  margin: 0 auto;
  padding: 15px 0px;
}

.sort-title {
  font-size: 15px;
  color: #555555;
  margin-bottom: 10px;
  font-weight: bold;
}

.nextBtn {
  width: 94%;
  margin: 0 auto;
  height: 50px;
  background: #1877ff;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
}

.s-times-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 5px;
}

.times-item {
  width: 80px;
  height: 30px;
  background: rgba(24, 119, 255, 0.05);
  border: 0.5px solid rgba(24, 119, 255, 0.2);
  color: #1877ff;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  margin: 5px 3px;
  font-size: 13px;
}

.times-item-active {
  background-color: #1877ff;
  color: #fff;
}

.timeRangeBox {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
  margin-top: 10px;
  background: #f7f7f7;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  color: #7e7e81;
}

.dc-btns {
  height: 45px;
  border-top: 1px solid #eee;
  display: flex;
}

.dc-items {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn1 {
  color: #1877ff;
}

.btn2 {
  background-color: #1877ff;
  color: white;
}

.scroll-summary {
  height: 400px;
}

.t-box {
  width: 155px;
  height: 44px;
  background: #f7f7f7;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 14px;
  color: #7e7e81;
}

.timeColorBlue {
  color: #1877ff;
}

.sort-box .el-radio-group {
  display: flex;
  flex-direction: column;
}

.timeRangeOutBox .el-date-editor.el-input {
  width: 178px;
}

.tip-wrapper {
  padding: 0 10px;
  margin-top: 10px;

  .use_study_content {
    // width: 650rpx;
    margin: 0 auto;
    background: #ffffff;
    border: 1px solid #dcdde0;
    border-radius: 8px;
    margin-top: 10px;
    padding: 10px;

    .study_title {
      height: 50px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: bold;
      text-align: center;
      color: #323b5a;
      line-height: 50px;
    }

    .study_subtitle {
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: Regular;
      text-align: left;
      color: #666666;
      margin: 10px 0;

      text {
        color: #4a73f8;
        font-weight: 600;
      }
    }

    .preview_effect {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: Regular;
      text-align: left;
      color: #666666;
      line-height: 20px;
    }
  }
}
</style>
